import React from "react";
import PropTypes from "prop-types";
import FieldFileInput from "./FieldFileInput";

const FieldFileInputsGroup = ({
    mode = 'horizontal',
    row = 0,
    readOnly = false,
    fields = [],
    actionComponent = undefined
}) => {
    const isVertical = mode === 'vertical';

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: isVertical ? 'column' : 'row',
                gap: '6px',
                flexWrap: 'wrap',
            }}
        >
            {fields
                .map(field => ({
                    ...field,
                    uploadDisabled: fields
                        .filter(f => typeof f.defaultValue === 'string' && f.defaultValue.length > 0)
                        .length > 0,
                }))
                .map((fieldProps, i) => (
                    <FieldFileInput key={i} row={row} {...fieldProps} />
                ))}
            {actionComponent && !readOnly && actionComponent}
        </div>
    );
};

FieldFileInputsGroup.propTypes = {
    mode: PropTypes.oneOf(['horizontal', 'vertical']),
    row: PropTypes.number,
    readOnly: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.shape({
        field: PropTypes.string.isRequired,
        label: PropTypes.string,
        defaultValue: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.instanceOf(File)
        ]),
        onChange: PropTypes.func.isRequired,
        allowedFileExtensions: PropTypes.arrayOf(PropTypes.oneOf(['.pdf', '.xml'])),
        required: PropTypes.oneOfType([PropTypes.bool]),
        readOnly: PropTypes.oneOfType([PropTypes.bool]),
        icon: PropTypes.element,
        iconOnly: PropTypes.bool,
    })).isRequired,
    actionComponent: PropTypes.oneOfType([
        PropTypes.element
    ])
};

export default FieldFileInputsGroup;
